import type { CalendarDayAggregate, CalendarShipmentItem } from '../types';

type CalendarRange = { start: string; end: string } | null | undefined;

const getShipmentId = (shipment: CalendarShipmentItem) =>
  shipment.shipment_id == null ? '' : String(shipment.shipment_id);

const isInRange = (date: string, range: CalendarRange) => {
  if (!range?.start || !range?.end) return false;
  return date >= range.start && date <= range.end;
};

export function getVisibleCalendarShipmentIds(
  calendarData: CalendarDayAggregate[] | null | undefined,
  range?: CalendarRange
): string[] {
  const ids = new Set<string>();

  (calendarData ?? []).forEach((dayAgg) => {
    if (!dayAgg?.date || !isInRange(dayAgg.date, range)) return;

    (dayAgg.top_shipments ?? []).forEach((shipment) => {
      const id = getShipmentId(shipment);
      if (id) ids.add(id);
    });

    (dayAgg.hour_aggregates ?? []).forEach((hourAgg) => {
      (hourAgg.top_shipments ?? []).forEach((shipment) => {
        const id = getShipmentId(shipment);
        if (id) ids.add(id);
      });
    });
  });

  return Array.from(ids);
}
